var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEthereum = function SvgEthereum(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "current",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M13.933 4.067 8.947 10.28c-1.134 1.413-.734 3.227.88 4.027L14.8 16.8c.653.32 1.72.32 2.373 0l4.974-2.493c1.613-.814 2.013-2.627.88-4.027l-4.974-6.213c-1.12-1.427-2.986-1.427-4.12 0ZM16 3.067v7.013"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m10.4 14.28 5.6-4.2 5.6 4.2M11.693 19.24l2.147.96a5.332 5.332 0 0 0 4.333 0l2.147-.96c1.92-.853 3.693 1.467 2.36 3.093l-4.613 5.64c-1.134 1.387-2.987 1.387-4.134 0l-4.6-5.64c-1.346-1.626.427-3.946 2.36-3.093Z"
  })));
};
export default SvgEthereum;